import SvgIcon from "../../SvgIcon/SvgIcon";

const DesktopTableInlineBody = ({ data, columns, actions, noDataMessage }) => {
  if (!data || data.length === 0) {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columns.length + (actions ? 1 : 0)}
            className="text-gray-600 dark:text-gray-300 px-4 py-6 text-center text-sm"
          >
            {noDataMessage}
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {data.map((row) => (
        <tr
          key={row.id}
          className="
            hover:bg-gray-50 dark:hover:bg-gray-700 border-b
            border-stroke transition
            dark:border-strokedark
          "
        >
          {/* 🔹 Celdas de datos */}
          {columns.map((col) => (
            <td
              key={col.accessor}
              className="text-gray-900 dark:text-gray-200 px-4 py-3 text-sm"
            >
              {col.render
                ? col.render(row[col.accessor], row)
                : row[col.accessor] ?? "—"}
            </td>
          ))}

          {/* 🔹 Acciones inline */}
          {actions && (
            <td className="px-4 py-2">
              <div className="flex justify-center gap-2">
                {(typeof actions === "function"
                  ? actions(row)
                  : actions
                )?.map((action, index) => (
                  <button
                    key={index}
                    onClick={() => action.onClick(row)}
                    className={`
                      inline-flex items-center gap-2
                      rounded-xl ${action.variant === 'danger' ? 'bg-danger' : 'bg-primary'}
                      px-3 py-2
                      text-xs font-medium text-white
                      shadow-1
                      transition-all duration-200
                      hover:scale-[1.02] hover:opacity-90
                      active:scale-[0.98]
                      whitespace-nowrap
                    `}
                  >
                    {action.icon && (
                      <SvgIcon name={action.icon} width={14} height={14} />
                    )}
                    {action.label}
                  </button>
                ))}
              </div>
            </td>
          )}
        </tr>
      ))}
    </tbody>
  );
};

export default DesktopTableInlineBody;
